import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import './styles.scss';
export default App;



// WEBPACK FOOTER //
// ./src/app/navigation/index.js